import React, {useEffect, useState} from 'react';

import {Button, FormControl, InputAdornment, Modal, OutlinedInput} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import Assets from '../../../helpers/assets';
import Colors from '../../../helpers/Colors';
import {ModalStyles} from './CubbyModalStyles';
import {CubbyModalLoadingPanel} from "./CubbyModalLoadingPanel";

export function CubbyNameInputModal({isOpen, onCancel, onClose, onCubbyAssign}) {
    const style = ModalStyles();
    const [cubbyId, setCubbyId] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(false);
        setCubbyId("");
    }, [isOpen]);

    const renderBodyContent = () => {
        return (
            <div className={style.container}>
                <IconButton className={style.closeButton} onClick={onClose}><CloseIcon/></IconButton>
                <div className={style.body}>
                    <div className={style.leftPanel}>
                        <img src={Assets.deliveryMan.default} alt="delivery man"/>
                    </div>
                    <div className={style.rightPanel}>
                        <div className={style.titleText}>Please type cubby number</div>
                        <FormControl fullWidth variant="outlined">
                            <OutlinedInput
                                id="cubby-name-input"
                                type='text'
                                value={cubbyId}
                                onChange={(event) => setCubbyId(event.target.value)}
                                fullWidth
                                placeholder="Enter Cubby Number"
                                className={style.inputField}
                                endAdornment={
                                    <InputAdornment position="end"/>
                                }
                            />
                        </FormControl>
                        <div className={style.buttonContainer}>
                            <Button type="submit"
                                    className={style.button}
                                    onClick={() => {
                                        onCancel()
                                    }}
                                    style={{color: Colors.grubtechBlue}}>
                                Cancel
                            </Button>
                            <Button type="submit"
                                    variant="contained"
                                    style={{backgroundColor: Colors.grubtechBlue, color: Colors.white}}
                                    onClick={() => {
                                        if (cubbyId.length > 0) {
                                            setIsLoading(true);
                                            onCubbyAssign(cubbyId);
                                        }
                                    }}
                                    className={style.button}>Assign
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            disableBackdropClick
            style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
        >
            {isLoading ? <CubbyModalLoadingPanel/> : renderBodyContent()}
        </Modal>
    );
}